// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import { get, trim } from 'lodash';
import { FormattedText } from '@elements';
import ServiceService from '../../../services/ServiceService';

type Props = {
  template: Object,
};

// A service template's price; "R$ 12,90 / U" when the clinic sells it by quantity, since the price is then per unit
const ServiceTemplatePrice = ({ template }: Props) => {
  const servicesByQuantity = useSelector(state => !!get(state, ['context', 'clinics', 'activeClinic', 'servicesByQuantity']));

  return (
    <React.Fragment>
      <FormattedText type="currency" text={get(template, 'price')} />
      {servicesByQuantity && ServiceService.isTemplateByQuantity(template) && ` / ${trim(template.unit)}`}
    </React.Fragment>
  );
};

export default ServiceTemplatePrice;
